// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-spinner {
  width: 100%;
}
.react-spinner .message {
  text-align: center;
}
.react-spinner .css-loader.loader-for-grid {
  margin: 0 auto !important;
  height: 20px !important;
  width: 20px !important;
  border-top-color: #697588 !important;
  border-right-color: #697588 !important;
  border-bottom-color: #697588 !important;
  border-left-color: #26282F !important;
  position: relative !important;
  margin-top: 0 !important;
}
.react-spinner .css-loader {
  margin: 10px auto;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border-top: 0.5em solid #00E383;
  border-right: 0.5em solid #00E383;
  border-bottom: 0.5em solid #00E383;
  border-left: 0.5em solid #002E33;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
}
.react-spinner .css-loader.ing {
  border-left: 0.5em solid #D92D20;
  border-top: 0.5em solid rgba(255, 98, 0, 0.2);
  border-right: 0.5em solid rgba(255, 98, 0, 0.2);
  border-bottom: 0.5em solid rgba(255, 98, 0, 0.2);
}
.react-spinner .css-loader,
.react-spinner .css-loader:after {
  border-radius: 50%;
  width: 4em;
  height: 4em;
}
@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
.react-spinner__inline {
  width: auto;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}
.react-spinner__inline .css-loader {
  width: 12px;
  height: 12px;
  border-width: 2px;
  margin-left: 5px;
}`, "",{"version":3,"sources":["webpack://./src/client/components/spinner/loader.scss"],"names":[],"mappings":"AAEA;EACI,WAAA;AADJ;AAEI;EACI,kBAAA;AAAR;AAEI;EACI,yBAAA;EACA,uBAAA;EACA,sBAAA;EACA,oCAAA;EACA,sCAAA;EACA,uCAAA;EACA,qCAAA;EACA,6BAAA;EACA,wBAAA;AAAR;AAEI;EACI,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,oBAAA;EACA,+BAAA;EACA,iCAAA;EACA,kCAAA;EACA,gCAAA;EACA,gCAAA;EAEA,wBAAA;EACA,6CAAA;EACA,qCAAA;AAAR;AAEI;EACI,gCAAA;EACA,6CAAA;EACA,+CAAA;EACA,gDAAA;AAAR;AAEI;;EAEI,kBAAA;EACA,UAAA;EACA,WAAA;AAAR;AAEI;EACI;IACI,+BAAA;IACA,uBAAA;EAAV;EAEM;IACI,iCAAA;IACA,yBAAA;EAAV;AACF;AAEI;EACI;IACI,+BAAA;IACA,uBAAA;EAAV;EAEM;IACI,iCAAA;IACA,yBAAA;EAAV;AACF;AAGE;EACE,WAAA;EACA,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,yBAAA;MAAA,sBAAA;UAAA,mBAAA;AADJ;AAEI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;AAAN","sourcesContent":["@import '../../Global/Colors';\n\n.react-spinner {\n    width: 100%;\n    .message {\n        text-align: center;\n    }\n    .css-loader.loader-for-grid {\n        margin: 0 auto !important;\n        height: 20px !important;\n        width: 20px !important;\n        border-top-color: $Gray90 !important;\n        border-right-color: $Gray90 !important;\n        border-bottom-color: $Gray90 !important;\n        border-left-color: $Gray200 !important;\n        position: relative !important;\n        margin-top: 0 !important;\n    }\n    .css-loader {\n        margin: 10px auto;\n        font-size: 10px;\n        position: relative;\n        text-indent: -9999em;\n        border-top: 0.5em solid $Green;\n        border-right: 0.5em solid $Green;\n        border-bottom: 0.5em solid $Green;\n        border-left: 0.5em solid $DeepSeaGreen;\n        -webkit-transform: translateZ(0);\n        -ms-transform: translateZ(0);\n        transform: translateZ(0);\n        -webkit-animation: load8 1.1s infinite linear;\n        animation: load8 1.1s infinite linear;\n    }\n    .css-loader.ing {\n        border-left: 0.5em solid $Red;\n        border-top: 0.5em solid rgba(255, 98, 0, 0.2);\n        border-right: 0.5em solid rgba(255, 98, 0, 0.2);\n        border-bottom: 0.5em solid rgba(255, 98, 0, 0.2);\n    }\n    .css-loader,\n    .css-loader:after {\n        border-radius: 50%;\n        width: 4em;\n        height: 4em;\n    }\n    @-webkit-keyframes load8 {\n        0% {\n            -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n        }\n        100% {\n            -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n        }\n    }\n    @keyframes load8 {\n        0% {\n            -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n        }\n        100% {\n            -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n        }\n    }\n\n  &__inline {\n    width: auto;\n    display: flex;\n    align-items: center;\n    .css-loader {\n      width: 12px;\n      height: 12px;\n      border-width: 2px;\n      margin-left: 5px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
